import React from "react";
import { LegalPage } from "./legal/LegalPage";

const SecurityDados = () => <LegalPage namespace="legalSecurityDados" />;

export default SecurityDados;
